import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classes from '../../../pipeline.module.scss';
import { Card } from '../../PipelineComponents';
import PivotsChart from './PivotsChart';
import PivotTable from './PivotTable';
import { isEmptyPivot, pivotToChart } from './pivotHelpers';

const isOneLinePivot = ({ data }) => data.length === 1;

const formattingChartData = (pivot, { axis, totals, withTotal }) => {
  const { columns = [], data = [] } = pivot || {};

  if (isOneLinePivot({ columns, data })) {
    const [row] = data;

    return {
      categories: columns,
      series: [{ name: 'Count', data: columns.map((column) => row[column] || 0) }],
    };
  }

  return pivotToChart({ columns, data }, { axis, totals, withTotal });
};

const PivotCard = ({
  title, caption = '', pivot, loading, firstLoad, tableProps = {}, chartProps = {}, height = 300,
}) => {
  const { axis, totals, withTotal } = chartProps;

  const chart = useMemo(() => (
    formattingChartData(pivot, { axis, totals, withTotal })
  ), [pivot, axis, totals, withTotal]);

  return (
    <Card
      title={title}
      caption={caption}
      loading={loading}
      firstLoad={firstLoad}
      isEmpty={isEmptyPivot(pivot)}
    >
      <PivotTable
        className={classes.bordered}
        {...tableProps}
        {...pivot}
      />

      <PivotsChart
        categories={chart.categories}
        series={chart.series}
        distributed={chartProps.distributed}
        showLegend={chartProps.showLegend}
        height={height}
      />
    </Card>
  );
};

PivotCard.propTypes = {
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
  pivot: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  firstLoad: PropTypes.bool,
  tableProps: PropTypes.object,
  chartProps: PropTypes.object,
  height: PropTypes.number,
};

export default PivotCard;
